import * as AWSCognito from 'amazon-cognito-identity-js';
import * as _ from 'lodash';
import {Roles} from '../common/enums/Roles'
import { UsersRepo } from '../users/users.repo'

import bugsnagClient from '../../bugsnag';
import { tradeSheets } from '../trading/tradesheets/tradesheets';

export class UserProfile {
  userPoolUserId: string;
  userPoolClientId: string;
  username: string;
  email: string;

  constructor(authToken: any) {
    this.userPoolUserId = authToken.sub;
    this.userPoolClientId = authToken.aud;
    this.username = authToken['cognito:username'];
    this.email = authToken.email;
  }

}

export class AuthService {

  private clientId: string;
  private poolId: string;
  private region: string;
  private cognitoUser: AWSCognito.CognitoUser;

  /** @ngInject */
  constructor(private $state: angular.ui.IStateService, private $http: angular.IHttpService, private $location: angular.ILocationService,
    private healthService: any, private jwtHelper: any, private $q: angular.IQService, private $mdDialog: angular.material.IDialogService, private usersRepo : UsersRepo) { }

  setAuthDetails() {
    return this.healthService.getHealthConfig()
      .then((res) => {
        this.clientId = res.data.awsUserPool.clientId;
        this.poolId = res.data.awsUserPool.userPoolId;
        this.region = res.data.awsUserPool.region;
      })
  }


  private getCurrentCognitoUser() {
    var poolData = {
      UserPoolId: this.poolId,
      ClientId: this.clientId
    };
    var userPool = new AWSCognito.CognitoUserPool(poolData);
    return userPool.getCurrentUser();
  }

  private getCurrentUserSession() {
    let that = this;
    let deferred = this.$q.defer();
    that.cognitoUser = that.getCurrentCognitoUser();
    if (that.cognitoUser != null) {
      that.cognitoUser.getSession(function (err, session: AWSCognito.CognitoUserSession) {
        if (err) {
          deferred.reject(err);
        } else {
          deferred.resolve(session);
        }
      });
    }
    return deferred.promise
  }

  private confirmForgotPasswordCallbacks(deferred: angular.IDeferred<{}>) {
    let that = this;
    return {
      onSuccess: function () {
        that.$state.go('login');
        deferred.resolve({ message: 'Password Reset Succesful' });
      },
      onFailure: function (err) {
        deferred.reject(err.message);
      }
    }
  }

  private forgotPasswordCallbacks(deferred: angular.IDeferred<{}>) {
    return {
      onSuccess: function () {
      },
      onFailure: function (err) {
        deferred.reject(err.message);
      },
      inputVerificationCode: (data: any) => {
        deferred.resolve({ message: 'verificationCodeSent' });
      }
    }
  }

  private setNewPasswordCallbacks(deferred: angular.IDeferred<{}>, cognitoUser: AWSCognito.CognitoUser, reLogin: boolean) {
    let that = this;
    return {
      onSuccess: function (result) {
        that.setSession(result);
        let roles = that.getUserRoles();
        // after setting the session
        // check if user has accepted terms and conditions
        that.hasUserAcceptedTermsAndConditions(roles,reLogin)

        deferred.resolve({ message: 'authenticated' });
      },

      onFailure: function (err) {
        deferred.reject(err.message);
      },

      newPasswordRequired: function (userAttributes, requiredAttributes) {
        // User was signed up by an admin and must provide new
        // password and required attributes, if any, to complete
        // authentication.

        deferred.resolve({
          message: 'newPasswordRequired',
          cognitoUser: cognitoUser
        });
      }
    }
  }


  login(username: string, password: string, reLogin: boolean) {
    let that = this;
    let deferred = this.$q.defer();
    var authenticationData = {
      Username: username,
      Password: password,
    };
    var authenticationDetails = new AWSCognito.AuthenticationDetails(authenticationData);
    var poolData = {
      UserPoolId: this.poolId,
      ClientId: this.clientId
    };
    var userPool = new AWSCognito.CognitoUserPool(poolData);
    var userData = {
      Username: username,
      Pool: userPool
    };
    that.cognitoUser = new AWSCognito.CognitoUser(userData);

    let callbacks = this.setNewPasswordCallbacks(deferred, that.cognitoUser, reLogin);

    that.cognitoUser.authenticateUser(authenticationDetails, callbacks);
    return deferred.promise;
  }

  completeNewPasswordChallenge(cognitoUser: AWSCognito.CognitoUser, newPassword: string, forgotPassword: boolean, verificationCode: any, reLogin) {
    //delete userAttributes.email_verified;
    let that = this;
    let deferred = this.$q.defer();
    if (!forgotPassword) {
      let callbacks = this.setNewPasswordCallbacks(deferred, cognitoUser, reLogin);
      cognitoUser.completeNewPasswordChallenge(newPassword, null, callbacks);
    }
    else {
      let callbacks = this.confirmForgotPasswordCallbacks(deferred);
      that.cognitoUser.confirmPassword(verificationCode, newPassword, callbacks);
    }
    return deferred.promise;
  }

  forgotPassword(username: string) {
    let deferred = this.$q.defer();
    let callbacks = this.forgotPasswordCallbacks(deferred);

    var poolData = {
      UserPoolId: this.poolId,
      ClientId: this.clientId
    };
    var userPool = new AWSCognito.CognitoUserPool(poolData);
    var userData = {
      Username: username,
      Pool: userPool
    };

    this.cognitoUser = new AWSCognito.CognitoUser(userData);
    this.cognitoUser.forgotPassword(callbacks);

    return deferred.promise;
  }

  confirmForgotPassword(verificationCode, newPassword) {
    let that = this;
    let deferred = this.$q.defer();
    let callbacks = this.confirmForgotPasswordCallbacks(deferred);
    that.cognitoUser.confirmPassword(verificationCode, newPassword, callbacks);
  }

  /*
    handleAuthentication() {
      this.angularAuth0.parseHash(function (err, authResult) {
        if (authResult && authResult.idToken) {
          this.setSession(authResult);
          this.$state.go('root.portfolio.portfolioSummary');
        } else if (err) {
          this.$timeout(function () {
            this.$state.go('root.portfolio.portfolioSummary');
          });
          console.log(err);
          alert('Error: ' + err.error + '. Check the console for further details.');
        }
      });
    }
  */

  setSession(userSession: AWSCognito.CognitoUserSession) {
    localStorage.setItem("id_token", userSession.getIdToken().getJwtToken());
    localStorage.setItem("access_token", userSession.getAccessToken().getJwtToken());
    localStorage.setItem("refresh_token", userSession.getRefreshToken().getToken());
    this.$http.defaults.headers.common['Authorization'] = `Bearer ${userSession.getIdToken().getJwtToken()}`;
  }

  remove_tokens() {
    localStorage.removeItem("id_token");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }

  logout(event) {
    var that = this;
    this.$mdDialog.show({
      template: `<logout-dialog></logout-dialog>`,
      clickOutsideToClose: true
    })
      .then((result) => {
        if (result) {
          that.getCurrentCognitoUser().signOut();
          this.remove_tokens();
          that.cognitoUser = null;
          that.$state.go('login');
        }
      });
  }

  getIdToken() {
    return localStorage.getItem("id_token");
  }

  setIdToken(id_token) {
    return localStorage.setItem("id_token", id_token);
  }

  hasSignedIn() {
    return !!this.getIdToken();
  }

  hasUserAcceptedTermsAndConditions  = (roles,reLogin) => {
    this.usersRepo.hasUserAcceptedTermsConditions()
    .then(res => {
      console.log("has user accepted terms and conditions ", res.data)
      if(res.data){
        this.routeUser(roles,reLogin)
      }else{
        this.acceptTermsAndConditions(roles,reLogin)
      }
    });

  }

  acceptTermsAndConditions = (roles, reLogin) => {
    var that = this;
    this.$mdDialog.show({
      template: `<terms-conditions></terms-conditions>`,
      clickOutsideToClose: true
    })
      .then((result) => {
        if (result) {
          // send request to accept terms and conditions
          that.usersRepo.acceptTermsConditions()
          .then(res => {
            if(res.data == true){
              that.routeUser(roles,reLogin);
            }
          })
        }
        if(result == false){
          that.getCurrentCognitoUser().signOut();
          this.remove_tokens();
          that.cognitoUser = null;
          that.$state.go('login');
        }

      })
      .catch(err => {
        console.log(err.data)
      })
      ;
  }


  routeUser = (roles, reLogin) => {
    let that = this;
    if (!reLogin) {
      bugsnagClient.user = {
        id: that.getUserCognitoId(),
        userName: that.getUserName()
      };

      if (that.$location.search().redirectUrl) {
        that.$location.path(that.$location.search().redirectUrl).search({});
      } else if ( _.indexOf(roles, Roles.PortfolioTeam) > -1 || _.indexOf(roles, Roles.SeniorManagement) > -1 ||
                  _.indexOf(roles, Roles.SystemAdministrator) > -1  || _.indexOf(roles, Roles.ViewOnly) > -1) {
        that.$state.go('root.portfolioManagement');
      }
      else if (_.indexOf(roles, Roles.UserAdministrator) > -1 ) {
        that.$state.go('root.users');
      }
      else if (_.indexOf(roles, Roles.Client) > -1) {
        that.$state.go('root.portfolio.portfolioSummary');
      } else if (_.indexOf(roles, Roles.Accountant) > -1 || _.indexOf(roles, Roles.SeniorAccountant) > -1 ) {
        that.$state.go('root.fees');
      }
      else if (_.indexOf(roles, Roles.FinancialAnalyst) > -1 ) {
        that.$state.go('root.cmodel');
      }
      // } else {
      //   that.$state.reload();
    }
  }



  renewAuth() {
    let that = this;
    this.getCurrentUserSession()
      .then((session: AWSCognito.CognitoUserSession) => {
        this.getCurrentCognitoUser().refreshSession(session.getRefreshToken(), (err, result) => {
          if (!err) {
            that.setSession(result);
          }

        });
      })
  }


  getAuthUserProfile(): UserProfile {
    let idToken = this.getIdToken();
    /*
    var isExpiredToken = false;
    var dateNow = new Date();

    if(decodedToken.exp < dateNow.getTime()) {
          isExpiredToken = true;
    }
    let expDate = this.jwtHelper.getTokenExpirationDate(idToken);
    */
    if (!idToken)
      return null;
    let authDetails = this.jwtHelper.decodeToken(idToken);
    if (!authDetails)
      return null;
    return new UserProfile(authDetails);
  }

  getUserName() {
    let user = this.getAuthUserProfile()
    if (user)
      return user.email;

    return 'Unknown';
  }

  getUserCognitoId() {
    let user = this.getAuthUserProfile()
    if (user)
      return user.userPoolUserId;

    return 'Unknown';
  }

  getUserRoles(): Array<string> {
    let idToken = this.getIdToken();
    if (!idToken)
      return null;
    let authDetails = this.jwtHelper.decodeToken(idToken);
    if (authDetails && authDetails['cognito:groups']) {
      return authDetails['cognito:groups'] as Array<string>;
    }
  }

  openLoginDialog() {
    // Checking if there's an existing Dialog so it doesn't have to keep
    // popping up on multiple requests
    var existingDialog = document.getElementsByTagName('md-dialog')
    if (!existingDialog.length) {
      this.remove_tokens();
      this.$mdDialog.show({
        template: `<login-dialog></login-dialog>`,
        escapeToClose: false,
        multiple: true
      })
        .then((result) => {
          if (!result) {
            this.$mdDialog.show(
              this.$mdDialog.alert()
                .title('Error')
                .textContent('Please ensure that you entered the correct email and password.')
                .ok('Ok')
            ).then((res) => this.openLoginDialog());
          }
        });
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/common/auth.service.ts